import React from "react";
import currencyFormatter from "currency-formatter";

import Config from "../config";
import { Button, TopText, BottomText } from "./styles";
import { EasyScalePopup } from "../zoid/popup";
import venteGreGreBruxelles from "../computationApps/vente-gre-gre-bruxelles";
import venteGreGreWallonie from "../computationApps/vente-gre-gre-wallonie";
import { WALLONIE, BRUXELLES } from "../store/constants/questions";
import AppSettings from "../utils/app_settings";
import recordEvent from "../analytics";
import { GraphQLClient } from "graphql-request";
import { PRESSION_IMMOBILIERE_OPTION } from "../computationApps/data/pression_immobiliere";

const settingsQuery = `query organisationSettings($organisationId: ID!){
    organisationSettings(organisationId: $organisationId) {
        name
        shortcode
        category
        content
    }
  }`;

class ComputeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      settings: undefined
    };
  }
  openPopup = async () => {
    recordEvent("buttonClicked", {
      organisationId: this.props.organisationId,
      url: await this.props.sourceUrl()
    });
    EasyScalePopup.renderTo(
      window.parent,
      {
        organisationId: this.props.organisationId,
        prix: this.props.prix,
        typeBien: this.props.typeBien,
        region: this.props.region,
        env: process.env.NODE_ENV,
        logLevel: process.env.NODE_END === "production" ? "error" : "debug"
      },
      "body"
    );
  };
  async componentDidMount() {
    this.client = new GraphQLClient(AppSettings.apiUrl, {
      mode: "cors"
    });
    console.log(this.props.organisationId);
    let { organisationId } = this.props;
    let data = await this.client
      .request(settingsQuery, {
        organisationId
      })
      .catch(e => {
        console.error("Error while loading settings", e.message, e);
      });
    if (!data.organisationSettings || data.organisationSettings.length === 0) {
      console.error("This organisation doesn't exist");
    }
    this.setState({
      loading: false,
      settings: data.organisationSettings
    });
  }
  render() {
    let { loading, settings } = this.state;
    if (loading) {
      return (
        <Button
          onClick={e => {
            e.preventDefault();
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <svg
              viewBox="0 0 600.44 693.33331"
              height={35}
              width={35}
              id="svg2"
              version="1.1"
            >
              <g
                transform="matrix(1.3333333,0,0,-1.3333333,0,693.33333)"
                id="g10"
              >
                <g transform="scale(0.1)" id="g12">
                  <path
                    id="path14"
                    style={{
                      fill: "#FFF",
                      fillOpacity: "1",
                      fillRule: "nonzero",
                      stroke: "none"
                    }}
                    d="M 3285.64,3351.59 4101.52,3822.65 2251.65,4890.69 401.797,3822.65 1217.68,3351.64 2251.65,3948.61 Z M 1351.59,3119.65 v -881.2 l 900.06,535.11 900.09,-535.11 v 881.2 l -900.09,519.65 z m 131.01,-1114.96 769.05,-444 769.09,444 -769.09,457.26 z M 267.852,1454.64 2251.65,309.309 4235.47,1454.64 V 3590.63 L 3419.59,3119.61 V 1925.69 l -1167.94,-674.3 -1167.91,674.3 V 3119.61 L 267.852,3590.63 Z M 0,1299.98 v 2600 L 2251.65,5200 4503.32,3899.98 v -2600 L 2251.65,0 0,1299.98"
                  />
                </g>
              </g>
            </svg>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginLeft: "10px"
              }}
            >
              <TopText>Calculer mes frais d'achat</TopText>
              <BottomText>
                Frais de base: chargement... <span role="img">💶</span>
              </BottomText>
            </div>
          </div>
        </Button>
      );
    }
    let computationApp;
    let values;
    if (this.props.region === WALLONIE) {
      computationApp = venteGreGreWallonie;
      values = {
        prix: this.props.prix,
        droitEnregistrement: 12.5,
        annexe: false,
        pressionImmobiliere: PRESSION_IMMOBILIERE_OPTION[0].value, //Default Zone à pression Immobilière
        abattement: false,
        nombreBiens: 0
      };
    } else {
      computationApp = venteGreGreBruxelles;
      values = {
        prix: this.props.prix,
        annexe: false,
        abattement: false,
        abattementTerrain: false,
        nombreBiens: 0
      };
    }
    let series = computationApp.compute(settings, values).series;
    let price = 0;
    series.forEach(s => (price += s.value));
    let color = "#fff";
    let size = 35;
    return (
      <Button
        onClick={e => {
          e.preventDefault();
          this.openPopup();
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <svg
            viewBox="0 0 600.44 693.33331"
            height={size}
            width={size}
            id="svg2"
            version="1.1"
          >
            <defs id="defs6" />
            <g
              transform="matrix(1.3333333,0,0,-1.3333333,0,693.33333)"
              id="g10"
            >
              <g transform="scale(0.1)" id="g12">
                <path
                  style={{
                    fill: color,
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  }}
                  d={`m 2814.58,4875 -562.91,325 -562.92,-325 -562.92,-325 -562.912,-325 v 0 L 0.00390625,3900 v -650 0 L 562.91,2925 h 0.008 v 650 l 562.912,325 562.92,325 562.92,325 562.91,-325 v -650 h 0.01 -0.01 v -650 -650 h 0.01 l 562.91,-325 v 650 650 650 0 650 l -562.92,325`}
                />
                <path
                  id="path16"
                  style={{
                    fill: color,
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  }}
                  d="m 4503.33,1950 v 1300 h 0.01 -0.01 v 650 l -562.91,325 v 0 l -562.92,-325 562.92,-325 v -650 0 0 -650 -650 0 0 l -562.92,-325 -562.92,325 -562.91,325 -562.92,325 v 0 l -562.92,-325 562.92,-325 v 0 l 562.92,-325 562.91,-325 562.92,-325 v 0 l 562.92,325 562.91,325 h 0.01 -0.01 v 650"
                />
                <path
                  id="path18"
                  style={{
                    fill: color,
                    fillOpacity: "1",
                    fillRule: "nonzero",
                    stroke: "none"
                  }}
                  d="M 2814.58,975 2251.67,650 v 0 l -562.92,325 -562.92,325 -562.912,325 v 0 650 l 562.912,325 562.92,325 562.92,325 v 650 l -562.92,-325 v 0 0 L 1125.83,3250 562.918,2925 v 0 H 562.91 L 0.00390625,2600 v 0 -650 -650 L 562.918,975 1125.83,650 1688.75,325 2251.67,0 2814.58,325 v 0 0.012 V 975"
                />
              </g>
            </g>
          </svg>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginLeft: "10px"
            }}
          >
            <TopText>Calculer mes frais d'achat</TopText>
            <BottomText>
              Frais de base:{" "}
              {currencyFormatter.format(
                price,
                AppSettings.currencyOptionFormater
              )}€ <span role="img">💶</span>
            </BottomText>
          </div>
        </div>
      </Button>
    );
  }
}

export default ComputeButton;



// WEBPACK FOOTER //
// ./src/ButtonComponent/index.js